import { apiGet } from './client'

export type Lifecycle = 'draft' | 'backtested' | 'paper' | 'live' | 'paused' | 'archived'

export interface PlanSummary {
  id: string
  name: string
  description: string | null
  lifecycle: Lifecycle
  account_alias: string
  current_version_id: string
  poll_cadence_seconds: number | null
  metadata: Record<string, unknown>
  created_at: string
  updated_at: string
}

export interface PlanListResponse {
  count: number
  plans: PlanSummary[]
}

export interface PlanDetail extends PlanSummary {
  version: {
    id: string
    version_number: number
    payload: Record<string, unknown>
    coverage: Record<string, unknown> | null
    revision_reason: string | null
    created_at: string
  } | null
}

export const listPlans = (lifecycle?: Lifecycle, accountAlias?: string) =>
  apiGet<PlanListResponse>('/plans', { params: { lifecycle, account_alias: accountAlias } })

export const getPlan = (planId: string, version?: number) =>
  apiGet<PlanDetail>(`/plans/${planId}`, { params: { version } })
